import _ from 'lodash'
import i18n from '@/lang'
import { isHexColor, isRGB, isRGBA } from '@com/utils/color'

/**
 * @param {string} attr
 * @param {string|number|boolean|string[]|number[]} val
 */
export function cookStyleSchema(attr, val) {
  const text = i18n.t('playTurbo.creative.languagePacks')
  function transformLabel(attr) {
    const dic = {
      color: text.fontColor,
      fontSize: text.fontSize,
      font: text.font,
      stroke: text.borderThickness,
      strokeColor: text.borderColor,
      blod: text.bold,
      bold: text.bold, // 有的素材是用bold,有的是blod,做个兼容
      alpha: text.alpha,
      italic: text.italic,
      enableShadow: text.enableShadow,
      shadowColor: text.shadowColor,
      shadowBlur: text.shadowBlur,
      shadowOffsetX: text.shadowOffsetX,
      shadowOffsetY: text.shadowOffsetY,
      gradient: text.gradient,
      startColor: text.startColor,
      endColor: text.endColor,
      enableGlow: text.enableGlow,
      glowColor: text.glowColor,
      glowBlur: text.glowBlur,
      enableDeleteline: text.enableDeleteline,
      enableUnderline: text.enableUnderline,
      lineHeight: text.lineHeight,
      letterSpacing: text.letterSpacing
    }
    if (typeof dic[attr] !== 'undefined') {
      return dic[attr]
    }
    return attr
  }
  const schema = {
    fontSize: {
      component: 'input-number',
      label: transformLabel(attr),
      rules: [
        {
          required: true,
          trigger: 'blur'
        }
      ],
      field: {
        'controls-position': 'right',
        'min': 0
      }
    }
  }

  const additionalItems = {
    label: transformLabel(attr),
    component: 'input-number',
    rules: [{ required: true, trigger: 'blur' }],
    field: {
      'controls-position': 'right',
      'min': 0
    }
  }

  if (schema[attr]) {
    return schema[attr]
  }
  if (attr === 'color') {
    return {
      label: transformLabel(attr),
      rules: [
        {
          required: true,
          trigger: 'change'
        }
      ],
      component: 'font-color',
      field: {
        colorFormat: isRGBA(val) ? 'rgb' : 'hex',
        // rgb 格式的不需要展示透明度调节功能
        showAlpha: !!isRGBA(val) && !isRGB(val)
      }
    }
  }
  if (isHexColor(val) || isRGBA(val) || isRGB(val)) {
    return {
      label: transformLabel(attr),
      rules: [
        {
          required: true,
          trigger: 'change'
        }
      ],
      component: 'color-picker',
      field: {
        colorFormat: isRGBA(val) ? 'rgb' : 'hex',
        // rgb 格式的不需要展示透明度调节功能
        showAlpha: !!isRGBA(val) && !isRGB(val)
      }
    }
  }

  if (typeof val === 'boolean') {
    return {
      label: transformLabel(attr),
      component: 'switch'
    }
  }

  if (attr === 'font') {
    return {
      label: transformLabel(attr),
      component: 'font-selector',
      field: {
        options: [],
        clearable: true
      }
    }
  }

  if (attr === 'fontUrl') {
    return {
      visible: false,
      label: transformLabel(attr),
      component: 'plain-text'
    }
  }

  return additionalItems
}
/**
 * @param {Array} style
 */
export function cookStyle(style) {
  _.each(style || null, (item, key) => {
    // playable 中 i18n 中配置 rgba 的格式是将多个通道的值组合成数据的形式，如 [255, 255, 255, 1]
    // 将 [255, 255, 255, 1] 数组形式表示的 rgba 颜色值转换成的合法的 rgba
    // playable 配置的是数组格式，素材仓库消费的是 rgba(0, 0, 0) 格式
    if (Array.isArray(item) && isRGBA(item)) {
      style[key] = `rgba(${item.join(',')})`
    }
    if (Array.isArray(item) && isRGB(item)) {
      style[key] = `rgb(${item.join(',')})`
    }
  })
  return style
}
